import { useState } from "react";
import Api from "../functions/Api";
import { ValidationResponse } from "../functions/validation";

const useEstadis = ({ handleMuestraSnack }) => {
  const [ejecutaapi] = Api();
  const [estadisticas, setEstadisticas] = useState([]);
  const [fechasM, setFechasM] = useState([]);

  const [estadisLotes, setEstadisLotes] = useState([]);

  const [estadisClientes, setEstadisClientes] = useState([]);

  const usuario = localStorage.getItem("user");


  const [totalAmortizaciones, setTotalAmortizaciones] = useState([]);



  const getEstadisticas = (fechaIni, fechaFin) => {
    //setEstadisticas([]);

    let body = JSON.stringify({ fechaIni: fechaIni, fechaFin: fechaFin });
    ejecutaapi("obtieneEstadisticas", body).then(data => {
      let { result, error } = ValidationResponse(data);

      if (error !== "") handleMuestraSnack(error, "error");

      const pagos1 = JSON.parse(result[0].pagos);
      console.log("obtieneEstadisticas", pagos1);

      setEstadisticas(pagos1);

      console.log("ressss", result);
      console.log("ressss", estadisticas);
    });
  };

  const getEstadisticasMontoRango = (fechaIni, fechaFin) => {
    //setEstadisticas([]);

    let body = JSON.stringify({ fechaIni: fechaIni, fechaFin: fechaFin });
    ejecutaapi("obtieneEstadisticasMontoRango", body).then(data => {
      let { result, error } = ValidationResponse(data);

      if (error !== "") handleMuestraSnack(error, "error");

      const fechasM = JSON.parse(result[0].fechasM);
      if (fechasM === null) {
        console.log("entro al nulo", estadisticas);
        setFechasM(fechasM);
      }
      setFechasM(fechasM);

      console.log("ressMMMMMss", result);
      console.log("ressMMMMMss", estadisticas);
    });
  };

  const getEstaisticasLotes = () => {
    //setEstadisticas([]);

    let body = JSON.stringify({});
    ejecutaapi("ObtEstadisticasLotes", body).then(data => {
      let { result, error } = ValidationResponse(data);
      if (error !== "") handleMuestraSnack(error, "error");
      setEstadisLotes(result);
    });
  };

  const getEstadisticasClientes = () => {
    //setEstadisticas([]);

    let body = JSON.stringify({});
    ejecutaapi("ObtEstadisticasClientes", body).then(data => {
      let { result, error } = ValidationResponse(data);
      if (error !== "") handleMuestraSnack(error, "error");
      console.log("AAAQQQQQUIIII", result);
      const cTotales = JSON.parse(result[0].C_TOTALES);
      setEstadisClientes(cTotales);
    });
  };


  const getAmortizacionesTotales = () => {
    //setEstadisticas([]);

    let body = JSON.stringify({});
    console.log('jsonString',body);
    ejecutaapi("obtieneAmortizacionesTotales", body).then(data => {

      console.log('primer result',data);
      let { result, error } = ValidationResponse(data);

      if (error !== "") handleMuestraSnack(error, "error");
      console.log("entro al result obtieneAmortizacionesTotales", result);

      if (result !== null) {
        
        const newData = result.map(item => {
          const amortizacion = typeof item.JTBL_AMORTIZACION === 'string' 
            ? JSON.parse(item.JTBL_AMORTIZACION) 
            : item.JTBL_AMORTIZACION;
          return {
              ...item,
              JTBL_AMORTIZACION: amortizacion
          };
      });

      function roundToTwoDecimalPlaces(value) {
        return Math.round(value * 100) / 100;
      }

      newData.forEach((parentObj) => {
        const mensualidadesVencidas = parentObj.JTBL_AMORTIZACION.filter(
          (amortizacion) => amortizacion.estatus === "M"
        ).length;

        let sumatoriaMontos = 0;

        for (const amortizacion of parentObj.JTBL_AMORTIZACION) {
          if (amortizacion.estatus === "M") {
            sumatoriaMontos += parseFloat(amortizacion.moratorio);
          }
        }
      
        // Redondear la suma de los montos a dos decimales
        const sumatoriaMontos2 = sumatoriaMontos.toFixed(2)
      

        parentObj.MENSUALIDADES_VENCIDAS = mensualidadesVencidas;
        parentObj.SUMATORIA_MONTOS = sumatoriaMontos2; // Agrega la suma al objeto JSON

      });


        console.log("entro al newData", newData);
      
    
       setTotalAmortizaciones(newData);
      }
     

    });
  };




  
  const getProyeccionEfectivo = (fechaIni, fechaFin,setProyectaEfectivo) => {
    //setEstadisticas([]);

    let body = JSON.stringify({popcion:0, fechaIni: fechaIni, fechaFin: fechaFin });
    ejecutaapi("obtieneProyeccionEfectivoxFecha", body).then(data => {
      let { result, error } = ValidationResponse(data);

      if (error !== "") handleMuestraSnack(error, "error");

     
      console.log("obtieneProyeccionEfectivoxFecha", result);

      setProyectaEfectivo(result);

    });
  };

  return {
    estadisticas,
    getEstadisticas,
    fechasM,
    getEstadisticasMontoRango,
    estadisLotes,
    getEstaisticasLotes,
    estadisClientes,
    getEstadisticasClientes,
    totalAmortizaciones,
    getAmortizacionesTotales,
    getProyeccionEfectivo
  };
};

export default useEstadis;
